import { createFileRoute, Outlet } from '@tanstack/react-router'

// Layout route: /$employeeId/index.tsx renders the employee detail page,
// /$employeeId/leave_calendar/index.tsx renders the leave calendar — this
// file just needs to hand off to whichever child route matched.
export const Route = createFileRoute('/dashboard/hr_admin/employees/$employeeId')({
  component: RouteComponent,
})

function RouteComponent() {
  return <Outlet />
}
